import defaultParameters from 'offshore_pcb/pcb_fabrication/data/defaultParameters';

export const shouldUpdatePanelSize = (name) => [
  'board_length',
  'board_width',
  'array_x_qty',
  'array_y_qty',
  'tab_rout',
  'scoring',
].includes(name);

export const updatePanelSize = (state) => {
  const {
    board_length,
    board_width,
    array_x_qty,
    array_y_qty,
    tab_rout,
    scoring,
  } = state.parameters;

  if (
    parseFloat(board_length) &&
    parseFloat(board_width) &&
    parseInt(array_x_qty, 10) &&
    parseInt(array_y_qty, 10)
  ) {
    const arrayUp = parseInt(array_x_qty, 10) * parseInt(array_y_qty, 10);
    const arrayX = parseInt(array_x_qty, 10) * parseFloat(board_length);
    const arrayY = parseInt(array_y_qty, 10) * parseFloat(board_width);
    let panelSizeX = arrayX;
    let panelSizeY = arrayY;

    if (scoring === '1') {
      panelSizeX += 0.5;
      panelSizeY += 0.5;
    }

    if (tab_rout === '1') {
      panelSizeX += 0.1 * (parseInt(array_x_qty, 10) - 1);
      panelSizeY += 0.1 * (parseInt(array_y_qty, 10) - 1);

      if (!scoring) {
        panelSizeX += 0.5;
        panelSizeY += 0.5;
      }
    }

    state.parameters.array_up = $.number(arrayUp, 0);
    state.parameters.array_x = $.number(arrayX, 2);
    state.parameters.array_y = $.number(arrayY, 2);
    state.parameters.panel_size_x = $.number(panelSizeX, 2);
    state.parameters.panel_size_y = $.number(panelSizeY, 2);
  } else {
    state.parameters.array_up = $.number(0, 0);
    state.parameters.array_x = $.number(0, 2);
    state.parameters.array_y = $.number(0, 2);
    state.parameters.panel_size_x = $.number(0, 2);
    state.parameters.panel_size_y = $.number(0, 2);
  }
};

export const resetAdvancedSpecs = (state) => {
  state.parameters.gold_fingers = defaultParameters.gold_fingers;
  state.parameters.gold_thickness = defaultParameters.gold_thickness;
  state.parameters.min_trace_space = defaultParameters.min_trace_space;
  state.parameters.blind_buried_hole = defaultParameters.blind_buried_hole;
  state.parameters.pitch = defaultParameters.pitch;
  state.parameters.smallest_hole_size = defaultParameters.smallest_hole_size;
  state.parameters.plated_slots = defaultParameters.plated_slots;
  state.parameters.counterbores = defaultParameters.counterbores;
  state.parameters.controlled_impedance = defaultParameters.controlled_impedance;
  state.parameters.plated_edges = defaultParameters.plated_edges;
  state.parameters.countersink = defaultParameters.countersink;
  state.parameters.controlled_dielectric = defaultParameters.controlled_dielectric;
};
